import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=3570d856&scoped=true"
var script = {}
import style0 from "./Container.vue?vue&type=style&index=0&id=3570d856&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.29.7__cache-loader@2.0.1_web_fe5e962fec43a62c82d69a5f09eb460e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3570d856",
  null
  
)

export default component.exports